import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { clsx } from 'clsx';

export interface ValidBlokProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  blok: any | any[];
  blokName?: string;
  isPreview?: boolean;
}
export function ValidBlok({
  children,
  blok,
  blokName,
  isPreview,
}: ValidBlokProps) {
  if (
    isPreview &&
    (!blok || (Array.isArray(blok) && blok.every((el) => !!el)))
  ) {
    return (
      <div className={clsx('my-4')} data-testid='invalid-block'>
        <h3 className='h3'>
          The selected <span className='text-red text-bold'>{blokName}</span>{' '}
          blok does not exist
        </h3>
        <p className='body text-red'>
          Please check the selected blok is <b>published</b> or exist in
          Storyblok
        </p>
      </div>
    );
  }
  return <>{children}</>;
}
export default ValidBlok;
